import useModal from '@hooks/useModal'
import { Button, Table, TableColumnType } from 'antd'
import { ContractAdditions } from 'gadjet-v2-types/dist/model'
import { useMemo } from 'react'

import { krw } from '@utils/format'

import ModalAlert from '@components/molecules/ModalAlert'

export default function Addition({ contract }: ContractColumnProps): JSX.Element {
  const { contractAdditions } = contract
  const [modal, onVisible, onClose] = useModal({ visible: false })

  const label = useMemo(() => {
    if (!contractAdditions || contractAdditions.length === 0) return '-'
    if (contractAdditions.length === 1) return contractAdditions[0].name
    return `${contractAdditions[0].name} 외 ${contractAdditions.length - 1}건`
  }, [contractAdditions])

  const columns: TableColumnType<ContractAdditions>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    { key: 'price', dataIndex: 'price', title: '계약가', render: (price) => krw(price) },
  ]

  return (
    <>
      <Button onClick={() => onVisible()}>{label}</Button>
      <ModalAlert title="부가서비스" visible={modal.visible} onCancel={onClose}>
        <Table
          rowKey={({ additionId }) => `${additionId}`}
          columns={columns}
          dataSource={contractAdditions || []}
          size="small"
          pagination={false}
        />
      </ModalAlert>
    </>
  )
}
